import * as React from "react"
import type { SVGProps } from "react"
const SvgGrowingMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M1.75 12.63a.96.96 0 0 1-.03-1.4l3.26-3.21q.59-.6 1.39-.59.8 0 1.38.59L8.9 9.15l2.7-2.72h-.78q-.4 0-.7-.28a1 1 0 0 1-.29-.7q0-.4.3-.7.28-.28.69-.28h3.16q.4 0 .7.29t.29.69V8.6q0 .4-.3.7-.27.28-.68.28-.4 0-.7-.28a1 1 0 0 1-.29-.68v-.8l-2.72 2.71q-.59.6-1.38.59-.8 0-1.38-.59L6.37 9.38l-3.24 3.25a.95.95 0 0 1-1.38 0" />
  </svg>
)
export default SvgGrowingMini
